/**
 * Consentement RGPD (bannière maison). Fichier nommé sans le mot « cookie »
 * pour limiter les faux positifs des bloqueurs (EasyPrivacy filtre *cookie*.js).
 */
(function () {
  var STORAGE_KEY = 'lesjus_cookie_consent_v1';

  function hideShopifyNativePrivacyUI() {
    try {
      document.querySelectorAll('[id^="shopify-pc"]').forEach(function (el) {
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
        el.style.setProperty('opacity', '0', 'important');
        el.style.setProperty('pointer-events', 'none', 'important');
      });
      document.querySelectorAll('shopify-pc__banner, shopify-pc__prefs__dialog').forEach(function (el) {
        el.style.setProperty('display', 'none', 'important');
      });
    } catch (e) {
      /* ignore */
    }
  }

  function startSuppressingShopifyBanner() {
    hideShopifyNativePrivacyUI();
    var obs;
    if (document.documentElement) {
      obs = new MutationObserver(function () {
        hideShopifyNativePrivacyUI();
      });
      obs.observe(document.documentElement, { childList: true, subtree: true });
    }
    var n = 0;
    var t = setInterval(function () {
      hideShopifyNativePrivacyUI();
      n += 1;
      if (n >= 150) {
        clearInterval(t);
        if (obs) obs.disconnect();
      }
    }, 100);
  }

  function withCustomerPrivacy(callback, retries) {
    retries = retries === undefined ? 40 : retries;
    if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function') {
      callback(window.Shopify.customerPrivacy);
      return;
    }
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        if (!err && window.Shopify && window.Shopify.customerPrivacy) {
          callback(window.Shopify.customerPrivacy);
        }
      });
      return;
    }
    if (retries > 0) {
      setTimeout(function () {
        withCustomerPrivacy(callback, retries - 1);
      }, 100);
    }
  }

  function syncShopifyConsent(accepted) {
    withCustomerPrivacy(function (api) {
      var payload = accepted
        ? { analytics: true, marketing: true, preferences: true }
        : { analytics: false, marketing: false, preferences: false };
      try {
        api.setTrackingConsent(payload, function () {});
      } catch (e) {
        /* ignore */
      }
    });
  }

  function updateCookieBannerSpace() {
    var html = document.documentElement;
    var root = document.getElementById('cookie-consent-banner');
    if (!root || html.classList.contains('cookie-consent-done')) {
      html.style.setProperty('--cookie-banner-space', '0px');
      return;
    }
    var h = root.offsetHeight;
    html.style.setProperty('--cookie-banner-space', (h > 0 ? h : 0) + 'px');
  }

  function setDone(value) {
    if (document.documentElement.classList.contains('cookie-consent-done')) {
      return;
    }
    try {
      localStorage.setItem(STORAGE_KEY, value);
    } catch (e) {
      /* ignore */
    }
    document.documentElement.classList.add('cookie-consent-done');
    document.documentElement.style.setProperty('--cookie-banner-space', '0px');
    var root = document.getElementById('cookie-consent-banner');
    if (root) {
      var ae = document.activeElement;
      if (ae && root.contains(ae) && typeof ae.blur === 'function') {
        ae.blur();
      }
      root.inert = true;
      root.setAttribute('hidden', '');
      root.style.display = 'none';
    }
    syncShopifyConsent(value === 'accepted');
    try {
      window.dispatchEvent(
        new CustomEvent('lesjus:cookie-consent', { detail: { value: value } })
      );
    } catch (e) {
      /* ignore */
    }
  }

  function onConsentClick(ev) {
    var target = ev.target;
    if (!target || !target.closest) return;
    var btn = target.closest('#cookie-consent-btn-accept, #cookie-consent-btn-reject, .cookie-consent-accept, .cookie-consent-reject');
    if (!btn) return;
    var banner = document.getElementById('cookie-consent-banner');
    if (!banner || !banner.contains(btn)) return;
    if (document.documentElement.classList.contains('cookie-consent-done')) {
      ev.preventDefault();
      return;
    }
    ev.preventDefault();
    ev.stopPropagation();
    if (btn.classList.contains('cookie-consent-accept') || btn.id === 'cookie-consent-btn-accept') {
      setDone('accepted');
    } else {
      setDone('rejected');
    }
  }

  function bindLayout() {
    var root = document.getElementById('cookie-consent-banner');
    if (!root) return;

    function scheduleSpace() {
      window.requestAnimationFrame(function () {
        updateCookieBannerSpace();
      });
    }
    scheduleSpace();
    window.addEventListener('resize', scheduleSpace);
    if (typeof ResizeObserver !== 'undefined') {
      try {
        var ro = new ResizeObserver(scheduleSpace);
        ro.observe(root);
      } catch (e) {
        /* ignore */
      }
    }
  }

  function init() {
    document.addEventListener('click', onConsentClick, true);

    if (document.getElementById('cookie-consent-banner')) {
      bindLayout();
    }
  }

  startSuppressingShopifyBanner();

  try {
    var existing = localStorage.getItem(STORAGE_KEY);
    if (existing === 'accepted' || existing === 'rejected') {
      syncShopifyConsent(existing === 'accepted');
    }
  } catch (e) {
    /* ignore */
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
